import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Excursions = () => {    
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" }, 
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-excursion1.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Excursions" breadEnd="Excursions" breadMid="Learning Approach" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <h5 className="color-red text-center">“Education beyond the school boundaries is true education. The learnings last longer and impart new vigour to the mind.”
</h5>
<p>In our constant endeavour to enhance the quality and learning experience provided to our learners and to link out-of-classroom learning with their curricular erudition, annual educational excursions are organized each year keeping in mind age appropriate destinations, sites, travel time, activities etc. to complement the holistic part of students education.

</p>
                            
                         <h5 className="color-red text-center">“Adventure is a path. Real adventure – self-determined, self-motivated, and often risky – forces one towards first-hand encounters with the world. The world, is not the way ones imagines... until it is experienced!”</h5>
                       <LazyLoad>     <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/excursion3.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <p>Keeping the above in mind the trips are designed around adventure camps, each giving a unique opportunity to learners to engage in alternate lifestyles away from their reality. Beginning with waking up at the crack of the dawn, getting ready to participate in various drills, walking miles in the woods to reach the mountain summit or walking on narrow trails, which prove arduous but at the same time, truly exhilarating and nerve-wracking. From getting trained on making optimal use of the limited resources available at hand to the survival amidst raw nature, away from technology and gadgets, these camps, in the lap of nature, prove to be refreshing change for the always-plugged in generation.</p>
                            <p>Activities such as Stream-running, Zip Line, Rappelling, Trekking, Raft making have taught learners, the importance of perseverance, balance and control, in addition to instilling a sense of accomplishment and self-worth. Team building exercises that precede each activity are targeted at charging up the learners for the various challenges. The night walk under the open sky has been a surreal experience. The camps end with an awards ceremony and the learners proclaim it a huge success!</p>
                            <p>The trips prove to be a grand triumph with a check on their endurance and unexplored energies. Trips are welcome break from their monotonous school routine, hence looked forward to keenly by all. The school trips are the highlights of the students’ lives as the fun time, the bonding, their pragmatic learning and experiences go a long way down the memory lane and reminiscences to cherish and look back on, with smiles and nostalgia!</p>
                        </div>

                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Excursions